import { IAppState } from 'shared/common/state';

export const selectIsBtpFlightRkActive = (state: IAppState) => state.btpFlightRkActive;
